export default __webpack_public_path__ + "static/media/not-authorized.ee4b4a8b.svg";